import React from 'react';
import PropTypes from 'prop-types';
import { FormInput } from '@ami/react/core';

export default class ReviewQuoteProductQuantity extends React.Component {
    static propTypes = {
        value: PropTypes.number.isRequired,
        maxQuantity: PropTypes.number,
        onChanged: PropTypes.func.isRequired
    };

    handleChange = (e) => {
        const { maxQuantity } = this.props;
        if (!e.target.value) {
            this.props.onChanged('');
            return;
        }
        var quantityInt = parseInt(e.target.value, 10);
        if (!maxQuantity || (maxQuantity && quantityInt <= maxQuantity)) {
            return this.props.onChanged(quantityInt);
        }
    };

    render() {
        const { value } = this.props;
        return (
            <FormInput
                id="fullName"
                type="number"
                label="Quantity"
                value={value}
                onChange={this.handleChange}
                className="w-1"
                min={1}
                required
            />)
    }
}
